/**
 * 페이지 접근 권한 체크 및 사용자 정보 관리
 * 로그인하지 않은 사용자를 로그인 페이지로 리디렉션
 */
(function() {
  'use strict';
  
  /**
   * 로그인 여부 확인
   * @returns {boolean} 로그인 여부
   */
  function checkAuth() {
    const isLoggedIn = sessionStorage.getItem('isLoggedIn');
    
    if (!isLoggedIn) {
      // 현재 페이지 URL 저장 (로그인 후 돌아올 페이지)
      const currentPage = window.location.pathname + window.location.search;
      const returnUrl = encodeURIComponent(currentPage);
      
      // 페이지 렌더링을 보장하기 위해 setTimeout 사용
      setTimeout(function() {
        // 사용자에게 알림
        alert('로그인을 하신 회원만 접근이 가능합니다.\n로그인 페이지로 이동합니다.');
        
        // 로그인 페이지로 리디렉션 (return URL 포함)
        window.location.href = '/auth/login?return=' + returnUrl;
      }, 100);
      
      return false;
    }
    
    return true;
  }
  
  /**
   * 사용자 정보 저장 (로그인 시 호출)
   * @param {object} userInfo - 사용자 정보 객체
   */
  function setUserInfo(userInfo) {
    if (!userInfo) {
      return;
    }
    
    // sessionStorage에 사용자 정보 저장
    sessionStorage.setItem('isLoggedIn', 'true');
    sessionStorage.setItem('comcode', userInfo.comcode || '0001');
    sessionStorage.setItem('csno', userInfo.csno || '');
    sessionStorage.setItem('custId', userInfo.custId || '');
    sessionStorage.setItem('custNm', userInfo.custNm || '');
    sessionStorage.setItem('birthDt', userInfo.birthDt || '');
    sessionStorage.setItem('email', userInfo.email || '');
    sessionStorage.setItem('mobileNo', userInfo.mobileNo || '');
    sessionStorage.setItem('telecomCd', userInfo.telecomCd || '');
    
    // 헤더 업데이트 이벤트 발생
    const authUpdateEvent = new CustomEvent('authUpdate', {
      detail: {
        isLoggedIn: true,
        custNm: userInfo.custNm,
        custId: userInfo.custId
      }
    });
    window.dispatchEvent(authUpdateEvent);
  }
  
  /**
   * 사용자 정보 가져오기
   * @returns {object} 사용자 정보 객체
   */
  function getUserInfo() {
    return {
      isLoggedIn: sessionStorage.getItem('isLoggedIn') === 'true',
      comcode: sessionStorage.getItem('comcode') || '0001',
      csno: sessionStorage.getItem('csno') || '',
      custNm: sessionStorage.getItem('custNm') || '',
      custId: sessionStorage.getItem('custId') || '',
      birthDt: sessionStorage.getItem('birthDt') || '',
      mobileNo: sessionStorage.getItem('mobileNo') || '',
      email: sessionStorage.getItem('email') || '',
      telecomCd: sessionStorage.getItem('telecomCd') || ''
    };
  }
  
  /**
   * 사용자 정보 삭제 (로그아웃 시 호출)
   */
  function clearUserInfo() {
    sessionStorage.clear();
    
    // 헤더 업데이트 이벤트 발생
    const authUpdateEvent = new CustomEvent('authUpdate', {
      detail: {
        isLoggedIn: false,
        custNm: '',
        custId: ''
      }
    });
    window.dispatchEvent(authUpdateEvent);
  }
  
  // 전역 함수로 노출 (Vue에서 사용 가능)
  window.checkAuth = checkAuth;
  window.setUserInfo = setUserInfo;
  window.getUserInfo = getUserInfo;
  window.clearUserInfo = clearUserInfo;
  
  // 자동 실행 비활성화: 필요한 컴포넌트에서만 window.checkAuth() 호출
  // 로그인이 필요한 페이지:
  // - loan: so_c2030, so_c2032, so_c2033, so_c2034, so_c2035
  // - mypage: so_c4010, so_c4020, so_c4030
  // - account-rules: so_c3000, so_c3002, so_c3003
  
  // 아래 자동 실행 코드는 주석 처리됨
  // window.addEventListener('load', checkAuth);
  // window.addEventListener('pageshow', function(event) {
  //   if (event.persisted) {
  //     checkAuth();
  //   }
  // });
})();
